// themes/archbound/index.js
//
// Central export point for the Archbound theme
// Bundles theme configuration, events, and story content

import archboundTheme from './archboundTheme.js';
import archboundEventsLibrary from './archboundEvents.js';
import archboundStoryLibrary from './archboundStory.js';

/**
 * Archbound Theme Bundle
 * Contains all configuration, content libraries, and narrative data
 * for the ancient ruins/archaeological mystery Archbound universe
 */
const archboundBundle = {
  // Theme configuration - visual, UI, and gameplay formatting
  theme: archboundTheme,
  
  // Event content library - backdrop, threat, morale, faction, discovery, campaign events
  events: archboundEventsLibrary,
  
  // Story content library - 4-chapter narrative arc and story threads
  story: archboundStoryLibrary
};

export default archboundBundle;

// Named exports for flexibility
export { archboundTheme, archboundEventsLibrary, archboundStoryLibrary };